import React from 'react';
import { useTour } from '../../context/TourContext';
import { useAppContext } from '../../context/AppContext';
import './TourButton.css';

/**
 * Reusable button that launches a Joyride tour.
 *
 * Props:
 *   steps       {Array}   - Joyride step objects for this page/modal
 *   iconOnly    {boolean} - Renders a compact icon-only pill (for modal headers)
 *   label       {string}  - Button label (ignored when iconOnly=true)
 *   className   {string}  - Extra class names
 */
const TourButton = ({ steps, iconOnly = false, label = 'Tutorial', className = '' }) => {
    const { startTour } = useTour();
    const { toursEnabled } = useAppContext();

    if (!steps || steps.length === 0) return null;
    if (!toursEnabled) return null;

    return (
        <button
            className={`tour-button${iconOnly ? ' tour-button--icon-only' : ''} ${className}`.trim()}
            onClick={() => startTour(steps)}
            title="Start tutorial"
            type="button"
        >
            <span className="tour-button__icon">?</span>
            {!iconOnly && <span>{label}</span>}
        </button>
    );
};

export default TourButton;
